// @flow
import api, { buildHeaders } from 'common/services/api';
import DateRange from 'common/domain/DateRange';

import HistoryEntry from '../domain/HistoryEntry';
import History from '../domain/History';
import { CentralMarket } from '../../centralMarkets/domain/CentralMarket';

class HistoryApi {

  async fetchMetricsHistory(token: string, callSign: string, dateRange: DateRange, centralMarket: ?CentralMarket) {
    const { from, to } = dateRange.toISO();

    const { data } = await api.get(
      `/statsradio/metrics/${callSign}/weekly/history`,
      { from, to, centralMarket: centralMarket && centralMarket.reference },
      { headers: buildHeaders(token) },
    );

    const entries = data.map(entry => HistoryEntry.parse(entry));
    return new History(entries);
  }
}

export default new HistoryApi();



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/services/HistoryApi.js